import React, { useState } from "react";
import {
    Button,
    Heading,
    VStack,
    Text,
    Box,
    Input,
    FormControl,
    FormErrorMessage,
    FormLabel,
    InputGroup,
} from "@chakra-ui/react";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";
import { FormPassword } from "../FormPassword";
import { CountryCodeSelect } from "../CountryCodeSelect";

const MotionBox = motion(Box);

export const SignIn = ({
    username,
    password,
    errorMessage,
    signinErrorMessage,
    isSigninError,
    showCountryCode,
    isError,
    isLoading,
    showPassword,
    onUserNameChange,
    onPasswordChange,
    toggleShowPassword,
    signIn,
    codeChange,
}) => {
    const [userPassword, setUserPassword] = useState(password);
    const navigate = useNavigate();
    return (
        <Box sx={{width: "100%"}}>
            <Text className='logo' sx={{margin: "0 0 20px", textAlign: "center"}}>EdShopify</Text>
            <MotionBox
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                maxW="md"
                mx="auto"
                p={{base: 0, sm: 6}}
                borderWidth={{base: "none", sm: "1"}}
                borderRadius={{base: "none", sm: "lg"}}
                shadow={{base: "none", sm: "lg"}}
                sx={{
                    minWidth: {base: "100%", sm: "400px"}
                }}
            >
                <VStack spacing={5}>
                    <Heading fontSize={"2xl"}>Welcome back</Heading>
                    <form onSubmit={signIn} style={{ width: "100%" }}>
                        <VStack spacing={5}>
                            <FormControl
                                padding="0"
                                colorScheme="brand"
                                isRequired={true}
                                isInvalid={isError}
                            >
                                {isSigninError && (
                                    <Text color="red.600" textAlign="center" padding="0 0 10px">
                                        {signinErrorMessage}
                                    </Text>
                                )}
                                <FormLabel>Email or Phone number</FormLabel>
                                <InputGroup>
                                    {showCountryCode && (
                                        <CountryCodeSelect codeChange={codeChange} />
                                    )}
                                    <Input
                                        type="text"
                                        name="username"
                                        placeholder="Email or Phone number"
                                        value={username}
                                        errorBorderColor="red.300"
                                        onChange={onUserNameChange}
                                        disabled={isLoading}
                                    />
                                </InputGroup>
                                <FormErrorMessage display="block">
                                    {errorMessage}
                                </FormErrorMessage>
                            </FormControl>
                            <FormPassword
                                label="Password"
                                name="password"
                                showPassword={showPassword}
                                toggleShowPassword={toggleShowPassword}
                                placeholder="password"
                                inputOnChange={(e) => {
                                    onPasswordChange(e);
                                    setUserPassword(e.target.value);
                                }}
                                value={userPassword}
                                formProps={{ isRequired: true }}
                                inputProps={{disabled: isLoading}}
                                padding="0"
                            />
                            <Button
                                colorScheme="blue"
                                _hover={{
                                    bg: "blue.500",
                                }}
                                width="100%"
                                type="submit"
                                isLoading={isLoading}
                                loadingText="Signing in"
                            >
                                Sign in
                            </Button>
                            <Button variant="link" colorScheme="blue" onClick={() => { navigate('/forgotpassword') }}>Forgot password?</Button>
                        </VStack>
                    </form>
                    <Text>
                        Don’t have an account? <Button variant="link" colorScheme="blue" onClick={() => { navigate('/signup') }}>Sign Up</Button>
                    </Text>
                </VStack>
            </MotionBox>
        </Box>
    );
};
